import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";

const Condona = ({
    datos,
    cadeteDni,
    ausencias = [],
    cierra,
    actualiza
}) => {

    const Usuario = ObtieneDatosCookies();

    const [seleccionadas, setSeleccionadas] = useState([]);
    const [observacion, setObservacion] = useState("");
    const [enviando, setEnviando] = useState(false);

    const token = btoa(
        `${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`
    );

    // =====================================================
    // DNI
    // =====================================================

    const dniFinal = cadeteDni || datos;

    // =====================================================
    // DETERMINAR USUARIO
    // =====================================================

    const usuarioCreo =
        Usuario?.identificacion ||
        Usuario?.dni ||
        Usuario?.nombre ||
        "Usuario no identificado";

    // =====================================================
    // SOLO INASISTENCIAS ACTIVAS
    // Si estado no existe, la consideramos activa
    // =====================================================

    const ausenciasActivas = useMemo(() => {

        return (ausencias || [])
            .filter((ausencia) => {

                if (
                    ausencia.estado === false ||
                    ausencia.estado === 0 ||
                    ausencia.estado === "0" ||
                    ausencia.estado === "Inactivo" ||
                    ausencia.estado === "Desactivada" ||
                    ausencia.estado === "Condonada"
                ) {
                    return false;
                }

                return true;
            })
            .sort((a, b) => {

                const fechaA = new Date(a.fecha);
                const fechaB = new Date(b.fecha);

                return fechaB - fechaA;
            });

    }, [ausencias]);

    // =====================================================
    // SI CAMBIAN LAS AUSENCIAS LIMPIAMOS SELECCIÓN
    // =====================================================

    useEffect(() => {
        setSeleccionadas([]);
    }, [ausencias]);

    // =====================================================
    // FORMATEAR FECHA
    // Evitamos problemas UTC usando directamente yyyy-mm-dd
    // =====================================================

    const formatearFecha = (fecha) => {

        if (!fecha) return "-";

        try {

            const solamenteFecha = String(fecha).split("T")[0];

            const partes = solamenteFecha.split("-");

            if (partes.length === 3) {
                return `${partes[2]}/${partes[1]}/${partes[0]}`;
            }

            return fecha;

        } catch (error) {

            return fecha;
        }
    };

    // =====================================================
    // ID DE LA INASISTENCIA
    // =====================================================

    const obtieneId = (ausencia) => {

        return (
            ausencia?.id ||
            ausencia?.idAusencia ||
            ausencia?.ausenciaId
        );
    };

    // =====================================================
    // SELECCIONAR / QUITAR UNA
    // =====================================================

    const alternarSeleccion = (ausencia) => {

        const id = obtieneId(ausencia);

        if (!id) {

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "La inasistencia seleccionada no posee un ID válido"
            });

            return;
        }

        setSeleccionadas((anteriores) => {

            if (anteriores.includes(id)) {

                return anteriores.filter(
                    (item) => item !== id
                );
            }

            return [
                ...anteriores,
                id
            ];
        });
    };

    // =====================================================
    // SELECCIONAR TODAS
    // =====================================================

    const seleccionarTodas = () => {

        const ids = ausenciasActivas
            .map((ausencia) => obtieneId(ausencia))
            .filter(Boolean);

        setSeleccionadas(ids);
    };

    // =====================================================
    // QUITAR TODAS
    // =====================================================

    const quitarTodas = () => {
        setSeleccionadas([]);
    };

    // =====================================================
    // MARCAR / DESMARCAR TODAS
    // =====================================================

    const alternarTodas = () => {

        const cantidadValidas = ausenciasActivas.filter(
            (ausencia) => obtieneId(ausencia)
        ).length;

        if (
            seleccionadas.length === cantidadValidas &&
            cantidadValidas > 0
        ) {
            quitarTodas();
        } else {
            seleccionarTodas();
        }
    };

    // =====================================================
    // DESCRIPCIÓN DE LAS SELECCIONADAS
    // =====================================================

    const faltasSeleccionadas = useMemo(() => {

        return ausenciasActivas.filter((ausencia) =>
            seleccionadas.includes(obtieneId(ausencia))
        );

    }, [ausenciasActivas, seleccionadas]);

    // =====================================================
    // CONDONAR
    // =====================================================

    const condonar = async () => {

        // =================================================
        // VALIDACIONES
        // =================================================

        if (seleccionadas.length === 0) {

            Swal.fire({
                icon: "warning",
                title: "Seleccione una inasistencia",
                text: "Debe seleccionar al menos una falta para condonar."
            });

            return;
        }

        if (!observacion.trim()) {

            Swal.fire({
                icon: "warning",
                title: "Falta la observación",
                text: "Debe indicar el motivo o resolución de la condonación."
            });

            return;
        }

        // =================================================
        // DETALLE PARA CONFIRMACIÓN
        // =================================================

        const detalle = faltasSeleccionadas
            .map(
                (ausencia) =>
                    `<div style="
                        text-align:left;
                        padding:5px 0;
                        border-bottom:1px solid #eee;
                    ">
                        <strong>${formatearFecha(ausencia.fecha)}</strong>
                        ${
                            ausencia.tipo
                                ? ` - ${ausencia.tipo}`
                                : ""
                        }
                    </div>`
            )
            .join("");

        const confirmacion = await Swal.fire({
            icon: "warning",
            title:
                seleccionadas.length === 1
                    ? "¿Condonar esta inasistencia?"
                    : `¿Condonar ${seleccionadas.length} inasistencias?`,
            html: `
                <div style="margin-bottom:15px;">
                    Las siguientes faltas serán
                    <strong>desactivadas</strong>
                    y dejarán de computar:
                </div>

                <div style="
                    max-height:220px;
                    overflow:auto;
                    padding:10px;
                    background:#f8f9fa;
                    border-radius:6px;
                    margin-bottom:15px;
                ">
                    ${detalle}
                </div>

                <div style="text-align:left;">
                    <strong>Observación:</strong><br/>
                    ${observacion}
                </div>
            `,
            showCancelButton: true,
            confirmButtonText:
                seleccionadas.length === 1
                    ? "Sí, condonar"
                    : `Sí, condonar ${seleccionadas.length}`,
            cancelButtonText: "Cancelar",
            reverseButtons: true
        });

        if (!confirmacion.isConfirmed) {
            return;
        }

        // =================================================
        // ENVIAR AL BACK
        // =================================================

        try {

            setEnviando(true);

            Swal.fire({
                title: "Procesando condonación...",
                html: `
                    Desactivando
                    <strong>
                        ${seleccionadas.length}
                    </strong>
                    ${
                        seleccionadas.length === 1
                            ? "inasistencia"
                            : "inasistencias"
                    }
                `,
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const response = await axios.post(
                process.env.REACT_APP_BASEURL +
                    "NCadetes/condonoInasistencia",
                {
                    cadeteDni: dniFinal,

                    observacion:
                        observacion.trim(),

                    usuarioCreo,

                    inasistencias:
                        seleccionadas
                },
                {
                    headers: {
                        Authorization:
                            `Basic ${token}`
                    }
                }
            );

            // =================================================
            // OK
            // =================================================

            await Swal.fire({
                icon: "success",
                title: "Condonación realizada",
                text:
                    response?.data?.message ||
                    (
                        seleccionadas.length === 1
                            ? "La inasistencia fue condonada correctamente."
                            : `${seleccionadas.length} inasistencias fueron condonadas correctamente.`
                    ),
                confirmButtonText: "Aceptar"
            });

            // =================================================
            // LIMPIAMOS
            // =================================================

            setSeleccionadas([]);
            setObservacion("");

            // =================================================
            // ACTUALIZAMOS EL CADETE
            // =================================================

            if (actualiza) {

                await actualiza();
            }

            // =================================================
            // CERRAMOS MODAL
            // =================================================

            if (cierra) {

                cierra();
            }

        } catch (error) {

            console.error(
                "Error condonando inasistencia:",
                error
            );

            Swal.fire({
                icon: "error",
                title: "No se pudo realizar la condonación",
                text:
                    error?.response?.data?.error ||
                    error?.response?.data?.message ||
                    "Ocurrió un error al intentar condonar las inasistencias."
            });

        } finally {

            setEnviando(false);
        }
    };

    // =====================================================
    // RENDER
    // =====================================================

    return (

        <div
            style={{
                width: "100%",
                padding: "15px"
            }}
        >

            {/* ================================================= */}
            {/* CABECERA                                          */}
            {/* ================================================= */}

            <div
                style={{
                    marginBottom: "15px"
                }}
            >

                <h4
                    style={{
                        marginBottom: "5px"
                    }}
                >
                    Condonar Inasistencias
                </h4>

                <div
                    style={{
                        color: "#666"
                    }}
                >
                    DNI: <strong>{dniFinal}</strong>
                </div>

            </div>

            {/* ================================================= */}
            {/* SIN FALTAS ACTIVAS                                */}
            {/* ================================================= */}

            {ausenciasActivas.length === 0 ? (

                <div
                    className="alert alert-success"
                >

                    <strong>
                        No posee inasistencias activas para condonar.
                    </strong>

                </div>

            ) : (

                <>

                    {/* ========================================= */}
                    {/* RESUMEN                                   */}
                    {/* ========================================= */}

                    <div
                        className="alert alert-info"
                        style={{
                            marginBottom: "15px"
                        }}
                    >

                        Inasistencias activas:

                        <strong>
                            {" "}
                            {ausenciasActivas.length}
                        </strong>

                        <br />

                        Seleccionadas:

                        <strong>
                            {" "}
                            {seleccionadas.length}
                        </strong>

                    </div>

                    {/* ========================================= */}
                    {/* SELECCIONAR TODAS                         */}
                    {/* ========================================= */}

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "10px",
                            gap: "10px",
                            flexWrap: "wrap"
                        }}
                    >

                        <label
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                cursor: "pointer",
                                fontWeight: "bold"
                            }}
                        >

                            <input
                                type="checkbox"
                                checked={
                                    ausenciasActivas.length > 0 &&
                                    seleccionadas.length ===
                                        ausenciasActivas.filter(
                                            (a) => obtieneId(a)
                                        ).length
                                }
                                onChange={alternarTodas}
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    cursor: "pointer"
                                }}
                            />

                            Seleccionar todas

                        </label>

                        {seleccionadas.length > 0 && (

                            <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary"
                                onClick={quitarTodas}
                            >
                                Quitar selección
                            </button>

                        )}

                    </div>

                    {/* ========================================= */}
                    {/* LISTA DE AUSENCIAS                        */}
                    {/* ========================================= */}

                    <div
                        style={{
                            maxHeight: "260px",
                            overflowY: "auto",
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            marginBottom: "20px"
                        }}
                    >

                        {ausenciasActivas.map(
                            (ausencia, index) => {

                                const id =
                                    obtieneId(ausencia);

                                const seleccionada =
                                    seleccionadas.includes(id);

                                return (

                                    <div
                                        key={
                                            id ||
                                            `${ausencia.fecha}-${index}`
                                        }
                                        onClick={() =>
                                            alternarSeleccion(
                                                ausencia
                                            )
                                        }
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "12px",

                                            padding: "12px",

                                            borderBottom:
                                                index <
                                                ausenciasActivas.length -
                                                    1
                                                    ? "1px solid #eee"
                                                    : "none",

                                            cursor: "pointer",

                                            background:
                                                seleccionada
                                                    ? "#f0f7ff"
                                                    : "white"
                                        }}
                                    >

                                        {/* CHECK */}

                                        <input
                                            type="checkbox"
                                            checked={seleccionada}
                                            onChange={() => {}}
                                            onClick={(e) =>
                                                e.stopPropagation()
                                            }
                                            onChangeCapture={() =>
                                                alternarSeleccion(
                                                    ausencia
                                                )
                                            }
                                            style={{
                                                width: "21px",
                                                height: "21px",
                                                cursor: "pointer",
                                                flexShrink: 0
                                            }}
                                        />

                                        {/* DATOS */}

                                        <div
                                            style={{
                                                flex: 1
                                            }}
                                        >

                                            <div
                                                style={{
                                                    fontWeight: "bold",
                                                    fontSize: "16px"
                                                }}
                                            >
                                                {formatearFecha(
                                                    ausencia.fecha
                                                )}
                                            </div>

                                            <div
                                                style={{
                                                    color: "#555"
                                                }}
                                            >

                                                Tipo:{" "}

                                                <strong>
                                                    {ausencia.tipo ||
                                                        "Inasistencia"}
                                                </strong>

                                            </div>

                                            {ausencia.justificada && (

                                                <div
                                                    style={{
                                                        fontSize:
                                                            "13px",
                                                        color: "#777"
                                                    }}
                                                >

                                                    Justificada:{" "}

                                                    {
                                                        ausencia.justificada
                                                    }

                                                </div>

                                            )}

                                            {ausencia.observacion && (

                                                <div
                                                    style={{
                                                        fontSize:
                                                            "13px",
                                                        color: "#777",
                                                        marginTop:
                                                            "3px"
                                                    }}
                                                >

                                                    Obs.:{" "}

                                                    {
                                                        ausencia.observacion
                                                    }

                                                </div>

                                            )}

                                        </div>

                                        {/* NUMERO */}

                                        <div
                                            style={{
                                                color: "#999",
                                                fontSize: "13px"
                                            }}
                                        >
                                            #{index + 1}
                                        </div>

                                    </div>
                                );
                            }
                        )}

                    </div>

                    {/* ========================================= */}
                    {/* OBSERVACION                               */}
                    {/* ========================================= */}

                    <div
                        className="form-group"
                        style={{
                            marginBottom: "20px"
                        }}
                    >

                        <label
                            style={{
                                fontWeight: "bold",
                                marginBottom: "6px"
                            }}
                        >
                            Observación / Resolución
                        </label>

                        <textarea
                            className="form-control"
                            rows="4"
                            value={observacion}
                            onChange={(e) =>
                                setObservacion(
                                    e.target.value
                                )
                            }
                            placeholder="Ej.: Condonada según Resolución N° 123/2026..."
                            disabled={enviando}
                        />

                        <small
                            style={{
                                color: "#777"
                            }}
                        >
                            Esta observación quedará registrada
                            en las faltas seleccionadas.
                        </small>

                    </div>

                    {/* ========================================= */}
                    {/* BOTÓN                                    */}
                    {/* ========================================= */}

                    <button
                        type="button"
                        className="btn btn-danger"
                        style={{
                            width: "100%",
                            padding: "10px",
                            fontWeight: "bold"
                        }}
                        disabled={
                            enviando ||
                            seleccionadas.length === 0 ||
                            !observacion.trim()
                        }
                        onClick={condonar}
                    >

                        {enviando
                            ? "Procesando..."
                            : seleccionadas.length === 0
                                ? "Seleccione una inasistencia"
                                : seleccionadas.length === 1
                                    ? "Condonar 1 inasistencia"
                                    : `Condonar ${seleccionadas.length} inasistencias`
                        }

                    </button>

                </>
            )}

        </div>
    );
};

export default Condona;